import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import { CloseOutlined, MenuOutlined } from "@ant-design/icons";
import cn from "classnames";
import logo from "../../assets/logo.svg";
import styles from "./header.module.css";
import { getUser } from "../../pages/selectors";
import permissions from "../../constants/permissions";
import { setUser } from "../../pages/actions";
import roles from "../../constants/roles";

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const user = useSelector(getUser);
  const dispatch = useDispatch();
  const { t } = useTranslation("header");

  const userCanManageApplications =
    user?.permissions?.includes(permissions.MANAGE_APPLICATIONS) && user.role === roles.ADMINISTRATOR;
  const userCanManageTenants = user?.permissions?.includes(permissions.MANAGE_TENANTS);

  const logOut = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    dispatch(setUser(null));
    closeMenu();
    navigate("/login");
  };

  const openMenu = () => {
    setIsMenuOpen(true);
  };

  const stopPropagation = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className={styles.header}>
      <div className={styles.headerInner}>
        <div className={styles.headerWrp}>
          <div className={styles.logo}>
            <Link to="/">
              <img className={styles.logoImg} src={logo} alt={t("orbitLogo")} />
            </Link>
          </div>
          <div className={cn(styles.menuWrp, isMenuOpen ? styles.isOpen : null)} onClick={closeMenu}>
            <div className={styles.closeMenuBtn} onClick={closeMenu}>
              <CloseOutlined />
            </div>
            <div className={styles.headerInnerWrp} onClick={stopPropagation}>
              <nav className={styles.nav}>
                {userCanManageApplications && (
                  <NavLink className={styles.navLink} to="/applications" onClick={closeMenu}>
                    {t("applications")}
                  </NavLink>
                )}
                {userCanManageTenants && (
                  <NavLink className={styles.navLink} to="/tenants" onClick={closeMenu}>
                    {t("tenants")}
                  </NavLink>
                )}
              </nav>
              <div className={styles.auth}>
                {user ? (
                  <>
                    <button onClick={logOut} className={cn(styles.logoutButton, styles.navLink)}>
                      {t("logout")}
                    </button>
                  </>
                ) : (
                  <>
                    <Link className={cn(styles.signInButton, styles.navLink)} to="/login">
                      {t("signIn")}
                    </Link>
                  </>
                )}
              </div>
            </div>
          </div>
          {!isMenuOpen && (
            <div className={styles.menuBtn} onClick={openMenu}>
              <MenuOutlined style={{ color: "white", fontSize: 20 }} />
            </div>
          )}
        </div>
      </div>
    </header>
  );
};
